import { Spin } from 'antd';
import type { SpinProps } from 'antd';

export interface DSpinProps extends SpinProps {}

export const DarwinSpin = (props: DSpinProps) => {
  return <Spin {...props} />;
};
